import React, {useState, useEffect, useCallback} from 'react';
import {AppState} from '../../../../store';

// HOOKS
import {useModal} from '../../../../../shared/components/Modal';
import {useSelector, useDispatch} from 'react-redux';

// SELECTORS
import {
  hotelierGallery as hotelierGallerySelectorFn,
  travellerGallery as travellerGallerySelectorFn,
  captivateGallery as captivateGallerySelectorFn,
  totalTravellerImages as totalImagesSelectorFn,
  hotelIdSelector,
  offerPersuasionSelector,
} from '../../selectors';
import useCurrentRoomData from '../../../../hooks/useCurrentRoomData';

// COMPONENTS
import ImageGalleryPopup from '../../../../../stories/components/hotels/SRP/ImageGalleryPopup/ImageGalleryPopup';
import TravellerPhotoUpload from '../../../../../stories/components/hotels/DetailsPage/TravellerPhotoUpload/TravellerPhotoUpload';
import MainGallery from '../../../../../stories/components/hotels/DetailsPage/MainGallery/MainGallery';
import Modal from '../../../../../shared/components/Modal';

// UTILS
import {updateUgcImages} from '../../redux/actions';
import {scrollToEl, detailsNavigationIdsAndValues} from '../../details.config';

//ACTIONS
import {fetchMoreImages} from '../../../UGC/redux/thunks';
import {updateSelectedPlace} from '../../../HotelsMap/redux/actions';

//Interfaces
import {IGallery} from '../../redux/types';

import * as S from './styles';

interface IPersuationType {
  name?: string;
  value?: string;
  coordinates?: Array<number | null>;
  _id?: string;
}

const GalleriesAndLocationPersuasion: React.FC<{
  locationPersuasions: IPersuationType[];
}> = ({locationPersuasions = []}) => {
  const hotelierImages = useSelector(hotelierGallerySelectorFn);
  const travellerImages = useSelector(travellerGallerySelectorFn);
  const captivateImages = useSelector(captivateGallerySelectorFn);
  const hotelId = useSelector(hotelIdSelector);
  const moreUgcImages = useSelector((state: AppState) => state.ugc.moreUgcImages);
  const totalTravellerImagesCount = useSelector(totalImagesSelectorFn);
  const dispatch = useDispatch();
  const offerPersuasion = useSelector(offerPersuasionSelector);
  const [typeOfGalleryPopup, updateTypeOfGalleryPopup] = useState('');
  const [totalUgcImages, updateTotalUgcImages] = useState(totalTravellerImagesCount);
  const captivateImagesCount = captivateImages.length;
  const currentRoomData = useCurrentRoomData();
  const {cbo} = currentRoomData;

  offerPersuasion.text =
    cbo && cbo.length && cbo[0].cbm
      ? cbo[0].cbm
      : !cbo || (cbo && !cbo.length)
      ? offerPersuasion.text
      : '';

  let formattedLocationPersuasions: {
    n?: string;
    value?: string;
    crd?: Array<number | null>;
    _id?: string;
    type?: string;
  } = {};

  if (!!locationPersuasions.length) {
    formattedLocationPersuasions = {
      n: locationPersuasions[0]?.name || '',
      value: locationPersuasions[0]?.value || '',
      crd: [locationPersuasions[0]?.coordinates[1], locationPersuasions[0]?.coordinates[0]] || [],
      _id: locationPersuasions[0]?._id || '',
      type: 'attraction',
    };
  }

  const setSelectedPlace = place => dispatch(updateSelectedPlace(place));

  const viewOnMap = () => {
    if (!!formattedLocationPersuasions?.crd?.length) {
      setSelectedPlace(formattedLocationPersuasions);
      scrollToEl(detailsNavigationIdsAndValues.location.id);
      return;
    }
    scrollToEl(detailsNavigationIdsAndValues.location.id);
  };

  const updateMoreUgcImages = useCallback(
    (vid, offset, lim) => {
      return dispatch(fetchMoreImages(vid, offset, lim));
    },
    [moreUgcImages],
  );

  let placeholderHotelierGalleryImage = '',
    placeholderTravellerGalleryImage = '';

  placeholderHotelierGalleryImage = (hotelierImages[0] || [])[2];
  if ((captivateImages[0] || {}).m === (hotelierImages[0] || [])[1]) {
    placeholderHotelierGalleryImage = (hotelierImages[1] || [])[2];
  }

  placeholderTravellerGalleryImage = (travellerImages[0] || []).b;
  if ((captivateImages[0] || {}).b === (travellerImages[0] || {}).b) {
    placeholderTravellerGalleryImage = (travellerImages[1] || {}).b;
  }

  const getMoreData = offset => {
    updateMoreUgcImages(hotelId, offset, 50);
    if (moreUgcImages.length === 0 && offset !== 0) {
      updateTotalUgcImages(travellerImages.length);
    }
  };

  useEffect(() => {
    let moreImages = [];
    moreUgcImages.map(item => {
      let ugcImage = {
        s: item.mobileThumbUrl,
        m: item.thumbUrl,
        b: item.bigUrl,
        tag: item.tags[0],
      };
      moreImages.push(ugcImage);
    });
    dispatch(updateUgcImages(travellerImages.concat(moreImages)));
  }, [moreUgcImages]);

  const [totalHotelierImages, setHotelImages] = useState<Array<IGallery>>([]);
  const [totalTravellerImages, setTravellerImages] = useState<Array<IGallery>>([]);

  const changeTypeOfGalleryPopup = type => {
    updateTypeOfGalleryPopup(type);
  };

  const getGalleryData = () => {
    let htl_capt: Array<IGallery> = captivateImages.filter(item => item.src == 'ing');
    let ugc_capt: Array<IGallery> = captivateImages.filter(item => item.src == 'ugc');

    if (htl_capt.length > 0) {
      hotelierImages.map(item => {
        let dupHotelImg = htl_capt.filter(i => i.m === item[1]);

        if (dupHotelImg.length === 0) {
          let hotellierImg = {s: item[0], m: item[1], b: item[2], tag: item[5]};
          htl_capt.push(hotellierImg);
        }
      });
    } else {
      hotelierImages.map(item => {
        let hotellierImg = {s: item[0], m: item[1], b: item[2], tag: item[5]};
        htl_capt.push(hotellierImg);
      });
    }

    if (ugc_capt.length > 0) {
      travellerImages.map(item => {
        let dupTravImg = ugc_capt.filter(i => i.m === item.m);
        if (dupTravImg.length === 0) {
          let travellerImg = {s: item.s, m: item.m, b: item.b, tag: item.tag || item.t};
          ugc_capt.push(travellerImg);
        }
      });
    } else {
      travellerImages.map(item => {
        let travellerImg = {s: item.s, m: item.m, b: item.b, tag: item.tag || item.t};
        ugc_capt.push(travellerImg);
      });
    }

    let galleryData = {
      hotelierData: htl_capt,
      travellerData: ugc_capt,
    };
    return galleryData;
  };

  useEffect(() => {
    const galleryData = getGalleryData();
    const {hotelierData, travellerData} = galleryData;
    setHotelImages(hotelierData);
    setTravellerImages(travellerData);
  }, [travellerImages]);

  const hotellierImagesCount = totalHotelierImages.length;

  const {
    isModalOpen: isGalleryModalOpen,
    closeModal: closeGalleryModal,
    openModal: openGalleryModal,
  } = useModal();

  return (
    <>
      <MainGallery
        alternateText={'Hotellier gallery placeholder'}
        dimension={'normalWidth'}
        data={captivateImages}
        onGalleryClick={() => {
          openGalleryModal();
          updateTypeOfGalleryPopup('hotellier');
        }}
        offerPersuasion={offerPersuasion}
      />

      <S.GallerySmallLocationWrap>
        <S.GalleryContainer
          onClick={() => {
            openGalleryModal();
            updateTypeOfGalleryPopup('hotellier');
          }}
        >
          <TravellerPhotoUpload
            source={placeholderHotelierGalleryImage}
            text={'HOTELIER'}
            alternateText={'hotelier gallery placeholder'}
            noOfPhotos={hotellierImagesCount}
          />
        </S.GalleryContainer>

        <S.LocationTopBlock>
          <S.LocationImage
            onClick={() => viewOnMap()}
            src="https://assets-gos3.goibibo.com/mapnew-1589195159.png"
            alt="location"
          />
        </S.LocationTopBlock>
      </S.GallerySmallLocationWrap>

      <Modal
        isOpen={isGalleryModalOpen}
        closeModal={closeGalleryModal}
        modalStyles={{width: '103.4rem'}}
      >
        {totalUgcImages > 0 && typeOfGalleryPopup === 'traveller' && (
          <ImageGalleryPopup
            data={totalTravellerImages}
            getMoreData={getMoreData}
            totalCount={totalUgcImages}
            typeOfPopup={'traveller'}
            changeTypeOfGalleryPopup={changeTypeOfGalleryPopup}
            tabsRequired={hotellierImagesCount > 0 ? true : false}
          />
        )}
        {captivateImagesCount > 0 && typeOfGalleryPopup === 'captivate' && (
          <ImageGalleryPopup
            data={captivateImages}
            totalCount={captivateImagesCount}
            typeOfPopup={'captivate'}
            changeTypeOfGalleryPopup={changeTypeOfGalleryPopup}
            tabsRequired={totalUgcImages > 0 ? true : false}
          />
        )}
        {hotellierImagesCount > 0 && typeOfGalleryPopup === 'hotellier' && (
          <ImageGalleryPopup
            data={totalHotelierImages}
            totalCount={hotellierImagesCount}
            typeOfPopup={'hotellier'}
            changeTypeOfGalleryPopup={changeTypeOfGalleryPopup}
            tabsRequired={totalUgcImages > 0 ? true : false}
          />
        )}
      </Modal>
    </>
  );
};

export default GalleriesAndLocationPersuasion;
